import { UserSetAvailabilityStatus } from '@api/generated/graphql';
import { logWorkspace, requireUser, updateUserStatus } from '../..';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import { userStatsFromAgentStats } from '../../types/ServiceUser';

async function handleAgentReady(event: Telecom.AgentReadyEvent) {
  const user = await requireUser(event.agentId);
  logWorkspace('service:agent:ready:' + user?.name, event);

  user.available = event.available;
  user.availabilityState = '';

  // set the user status as available. since we just received
  // the ready event, assume there's no change restrictions
  updateUserStatus(user.id, UserSetAvailabilityStatus.Available, true);

  user.stats = userStatsFromAgentStats(event.stats);

  // override to current time to workaround Kazoo issue
  user.stats.lastActionAt = new Date().toISOString();
}

export default handleAgentReady;
